import { Input, Form, Flex } from "antd";
import CustomButton from "../CustomButton/Button"; // adjust path if needed
import "./Input.scss";

const { Password, TextArea } = Input;

const isEmailField = (type, name) => {
  if (type === "email") return true;
  const fieldName = String(name || "").toLowerCase();
  return (
    fieldName === "email" ||
    fieldName.endsWith("email") ||
    fieldName.includes("email")
  );
};

const toLowerEmail = (value) =>
  typeof value === "string" ? value.toLowerCase() : value;

const CustomInput = ({
  label,
  name,
  rules,
  type = "text",
  placeholder,
  addonBefore,
  prefix,
  isPassword,
  iconRender,
  onBlur,
  disabled,
  rows = 4,
  verifyBtn = false,
  disableVerify = false,
  isVerified = false,
  handleVerify,
  verifyLoading,
  inputStyle,
  formItemStyle,
  isRequired = false,
  onChange,
  isUpperCase = false,
  removeHttps = false,
  maxLength,
  showCount,
  normalize,
  getValueProps,
  inputMode,
}) => {
  const shouldLowercaseEmail = isEmailField(type, name);

  const handleWheel = (e) => {
    if (type === "number") {
      e.currentTarget.blur();
    }
  };

  return (
    <Form.Item
      label={
        label && (
          <span>
            {label}
            {isRequired && (
              <span style={{ color: "red", marginLeft: 4 }}>*</span>
            )}
          </span>
        )
      }
      style={formItemStyle}
      className="custom-input-form-item"
    >
      {type === "textarea" ? (
        <Form.Item name={name} rules={rules} noStyle>
          <TextArea
            className="custom-input"
            placeholder={placeholder}
            rows={rows}
            onBlur={onBlur}
            disabled={disabled}
            maxLength={maxLength}
            showCount={showCount}
          />
        </Form.Item>
      ) : isPassword ? (
        <Form.Item name={name} rules={rules} noStyle>
          <Password
            className="custom-input"
            type={type}
            placeholder={placeholder}
            iconRender={iconRender}
            onBlur={onBlur}
            disabled={disabled}
          />
        </Form.Item>
      ) : (
        <Flex align="center" gap={verifyBtn ? 8 : 0}>
          <Form.Item
            name={name}
            rules={rules}
            noStyle
            normalize={normalize || (shouldLowercaseEmail ? toLowerEmail : undefined)}
            getValueProps={getValueProps}
          >
            <Input
              className="custom-input"
              type={type}
              style={inputStyle}
              addonBefore={addonBefore}
              prefix={prefix}
              placeholder={placeholder}
              onBlur={onBlur}
              disabled={disabled}
              onChange={onChange}
              onWheel={handleWheel}
              inputMode={inputMode}
              onInput={(e) => {
                let value = e.target.value;

                // Email fields → always lowercase
                if (shouldLowercaseEmail) {
                  value = value.toLowerCase();
                }

                // PAN / GST uppercase
                if (isUpperCase) {
                  value = value.toUpperCase();
                }

                // Remove duplicate https://
                if (removeHttps) {
                  value = value.replace(/^(https?:\/\/)+/gi, "");
                }

                e.target.value = value;
              }}
            />
          </Form.Item>

          {verifyBtn && (
            <CustomButton
              loading={verifyLoading}
              disabled={disableVerify}
              variant="solid"
              color="primary"
              style={{
                backgroundColor: isVerified ? "#00874F" : undefined,
                color: isVerified ? "#fff" : undefined,
                height: "50.6px",
              }}
              onClick={handleVerify}
            >
              {isVerified ? "Verified" : "Verify"}
            </CustomButton>
          )}
        </Flex>
      )}
    </Form.Item>
  );
};

export default CustomInput;
